<template>
    <svg width="132" height="132" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <defs>
    <circle id="a" cx="66" cy="66" r="66"/>
    <path id="c" d="m31.738 108.9 62.356 40.958 34.606-24.256 30.953-41.452L96.962 26.4z"/>
  </defs>
  <g fill="none" fill-rule="evenodd">
    <mask id="b" fill="#fff">
      <use xlink:href="#a"/>
    </mask>
    <use fill="#008CEA" xlink:href="#a"/>
    <g mask="url(#b)">
      <use fill="#008CEA" xlink:href="#c"/>
      <use fill-opacity=".235" fill="#000" xlink:href="#c"/>
    </g>
    <g mask="url(#b)">
      <path d="M29.7 28.462c0-1.139.913-2.062 2.038-2.062h65.224c1.125 0 2.038.923 2.038 2.063v78.374c0 1.14-.913 2.063-2.038 2.063H31.738c-1.125 0-2.038-.923-2.038-2.063V28.464Z" fill="#FFF" fill-rule="nonzero"/>
      <path d="M91.78 93.803a.95.95 0 0 1 .95.95v7.504a.95.95 0 0 1-.95.95H37.25a.95.95 0 0 1-.95-.95v-7.505a.95.95 0 0 1 .95-.95h54.53ZM67.65 89.1v3.135H36.3V89.1h31.35Zm24.13-15.097a.95.95 0 0 1 .95.95v7.505a.95.95 0 0 1-.95.95H37.25a.95.95 0 0 1-.95-.95v-7.505a.95.95 0 0 1 .95-.95h54.53ZM51.975 69.3v3.135H36.3V69.3h15.675ZM91.78 54.203a.95.95 0 0 1 .95.95v7.505a.95.95 0 0 1-.95.95H37.25a.95.95 0 0 1-.95-.95v-7.505a.95.95 0 0 1 .95-.95h54.53ZM61.38 49.5v3.135H36.3V49.5h25.08Zm30.4-11.797a.95.95 0 0 1 .95.95v7.505a.95.95 0 0 1-.95.95H37.25a.95.95 0 0 1-.95-.95v-7.505a.95.95 0 0 1 .95-.95h54.53ZM58.245 33v3.135H36.3V33h21.945Z" fill="#C7D0DC"/>
    </g>
  </g>
</svg>
</template>
<script>
export default {
    name: 'ClickIcon',
}
</script>